var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("名称："+_vm._s(_vm.info.name))]),_c('div',[_vm._v("地址："+_vm._s(_vm.info.address))]),_c('div',[_vm._v("联系电话："+_vm._s(_vm.info.phone))])])
}
var staticRenderFns = []

export { render, staticRenderFns }